import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiUser, FiTrendingUp} = FiIcons;

const Header = ({currentUser, onLoginClick, onDashboardClick}) => {
  return (
    <motion.div
      initial={{opacity: 0, y: -20}}
      animate={{opacity: 1, y: 0}}
      transition={{duration: 0.6}}
      className="mb-8"
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo and Tagline Section */}
        <div className="flex flex-col md:flex-row items-center gap-3">
          <img 
            src="https://ik.imagekit.io/cy1p3cqmc/endpoint/images/Logo/local-Trust-Guide-Logo.png" 
            alt="Local Trust Guide Logo" 
            className="h-14 w-auto" 
          />
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <p className="text-sm text-slate-500 font-bold uppercase tracking-wider">Restaurant Analytics</p>
            <p className="text-xs text-slate-400 font-medium max-w-[280px] md:max-w-none">
              We help restaurants grow without depending on ads.
            </p>
          </div>
        </div>

        {/* Actions Section */}
        <div className="flex flex-wrap items-center justify-center gap-3">
          <motion.a
            href="https://www.localtrustguide.com/join"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
            className="flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-xl shadow-lg hover:shadow-orange-200 transition-all duration-200 font-semibold text-sm"
          >
            <SafeIcon icon={FiTrendingUp} className="text-sm" />
            <span>Start Growing Today</span>
          </motion.a>

          {currentUser ? (
            <motion.button
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
              onClick={onDashboardClick}
              className="flex items-center gap-2 px-4 py-2.5 bg-white border-2 border-slate-200 text-slate-700 rounded-xl shadow-sm hover:border-blue-500 hover:text-blue-600 transition-all duration-200 font-medium text-sm"
            >
              <SafeIcon icon={FiUser} className="text-sm" />
              <span>{currentUser.name}</span>
            </motion.button>
          ) : (
            <motion.button
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
              onClick={onLoginClick}
              className="flex items-center gap-2 px-6 py-2.5 bg-slate-800 text-white rounded-xl shadow-lg hover:bg-slate-900 transition-all duration-200 font-medium text-sm"
            >
              <SafeIcon icon={FiUser} className="text-sm" />
              <span>Sign In</span>
            </motion.button>
          )}
        </div>
      </div>

      <div className="max-w-2xl mx-auto text-center mt-12">
        <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-4 tracking-tight">
          Restaurant Profit Calculator
        </h2>
        <p className="text-slate-600 text-lg leading-relaxed max-w-xl mx-auto">
          Calculate your daily, weekly, and monthly profits with detailed analytics to optimize your restaurant's financial performance.
        </p>
      </div>
    </motion.div>
  );
};

export default Header;